export default class {
	constructor(options) {
		this.defaults = {
			$el: null,
		};
		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace = "imgUpsize";
		if (this.options.$el) {
			this.$el = this.options.$el;
			this.init(true);
		}
	}

	init(bool) {
		if (bool) {
			// add class loading to this.$el, then get the src of the image
			// wait until the image is loaded, then remove the loading class
			// and add the loaded class
			this.$el.classList.add("js-load");
			this.$el.classList.add("loading");
			const img = new Image();
			img.onload = () => {
				this.$el.classList.remove("loading");
				this.$el.classList.add("loaded");
			};
			img.src = this.$el.src;
		}
	}
}
